import { uniq } from 'lodash';
import { ASN, getData, Prefix } from './common';

export const getPrefixRoutes = async (prefix: Prefix) => {
  const lookingGlassData = await getData<RrcData>('looking-glass', {
    resource: prefix,
    starttime: 'now',
  });

  const routes: Route[] = lookingGlassData.rrcs.flatMap(({ rrc, peers }) =>
    peers.map((peer) => {
      const asPath: ASN[] = peer.as_path.split(' ').map((asn) => Number(asn));
      const asPathWithoutPrepends = uniq(asPath);

      return {
        prefix: peer.prefix,
        rrcId: rrc,
        peerIp: peer.peer,
        asPath,
        originAsn: asPathWithoutPrepends[asPathWithoutPrepends.length - 1],
        upstreamAsn: asPathWithoutPrepends[asPathWithoutPrepends.length - 2] ?? null,
      };
    }),
  );

  return routes;
};

export interface Route {
  prefix: Prefix;
  rrcId: string;
  peerIp: string;
  asPath: ASN[];
  originAsn: ASN;
  upstreamAsn: ASN | null;
}

interface RrcData {
  rrcs: {
    rrc: string;
    peers: {
      asn_origin: ASN;
      as_path: string;
      prefix: Prefix;
      peer: string;
    }[];
  }[];
}
